// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';

import VoucherGroupsQuery from '../../components/Query/VoucherGroups';
import VoucherGroupDetail from './VoucherGroupDetail';
import { RouteComponentProps } from 'react-router';
import { Title } from '../../components/Layout/components';
import { exportRawPriceObject } from 'src/helpers/Prices/exportRawPriceObject';

interface IVoucherGroupsTableState {
  voucherGroup?: GQL.IVoucherGroup;
}

interface IVoucherGroupsTableProps extends RouteComponentProps<{ eshop: string }> {
  page: number;
  limit: number;
}

export default class VoucherGroupsTable extends React.Component<IVoucherGroupsTableProps, IVoucherGroupsTableState> {

  constructor(props: IVoucherGroupsTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <VoucherGroupsQuery eshopDomain={this.props.match.params.eshop}>
            {({ voucherGroups, deleteVoucherGroup, createVoucherGroup, updateVoucherGroup }: any) => {
              return this.renderData(
                voucherGroups,
                updateVoucherGroup,
                createVoucherGroup,
                deleteVoucherGroup,
                voucherGroups.refetch
              );
            }}
          </VoucherGroupsQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    voucherGroups: any,
    updateVoucherGroup: Function,
    createVoucherGroup: Function,
    deleteVoucherGroup: Function,
    refetch: Function
  ) {
    if (voucherGroups) {
      return (
        <div>
          <Title>Vouchers</Title>
          <Divider />
          <Button onClick={() => this.newVoucherGroup()}>Create new voucher group</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={voucherGroups.voucherGroups}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Title"
              dataIndex="title"
              key="title"
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              align="center"
              width={290}
              render={(u: any, row: any) => this.renderActions(u, row, deleteVoucherGroup, refetch)}
            />
          </Table>
          {this.state &&
            this.state.voucherGroup && (
              <VoucherGroupDetail
                domain={this.props.match.params.eshop}
                voucherGroup={this.state.voucherGroup}
                languages={voucherGroups.languages}
                onSave={a => this.upsert(a, createVoucherGroup, updateVoucherGroup, refetch)}
                onCancel={() => this.setCurrentVoucherGroup(undefined)}
              />
            )}
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading voucher groups ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, voucherGroup: GQL.IVoucherGroup, deleteVoucherGroup: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.goToVouchers(voucherGroup.id)}>
          Vouchers
        </Button>
        <Divider type={'vertical'} />
        <Button type={'dashed'} onClick={() => this.setCurrentVoucherGroup(voucherGroup)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(voucherGroup, deleteVoucherGroup, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private goToVouchers(voucherGroupId: string) {
    const eshop = this.props.match.params.eshop;
    this.props.history.push(`/${eshop}/application/vouchers/${voucherGroupId}`);
  }

  private newVoucherGroup(category?: any) {
    this.setCurrentVoucherGroup({});
  }

  private setCurrentVoucherGroup(voucherGroup: any) {
    this.setState({ voucherGroup });
  }

  private delete(voucherGroup: GQL.IVoucherGroup, deleteVoucherGroup: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${voucherGroup.title}?`,
      content: (
        <span>
          Are you sure you want to delete voucher group <strong>{voucherGroup.title}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteVoucherGroup({
          variables: {
            id: voucherGroup.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    voucherGroup: GQL.IVoucherGroup, 
    createVoucherGroup: Function, 
    updateVoucherGroup: Function, 
    refetch: Function
  ) {
    if (voucherGroup != undefined) {
      const variables = {
        id: voucherGroup.id,
        eshopDomain: this.props.match.params.eshop,
        voucherGroup: {
          active: voucherGroup.active !== null && voucherGroup.active !== undefined ? voucherGroup.active : true,
          title: voucherGroup.title,
          source: voucherGroup.source || 'percent',
          type: voucherGroup.type || 'price',
          amount: voucherGroup.amount,
          fixDiscountAmount: voucherGroup.fixDiscountAmount,
          applyToDiscountedGoods: voucherGroup.applyToDiscountedGoods,
          // staré ceny
          minimumPriceOfSingleItem: voucherGroup.minimumPriceOfSingleItem,
          maximumPriceOfSingleItem: voucherGroup.maximumPriceOfSingleItem,
          minimumPriceOfOrder: voucherGroup.minimumPriceOfOrder,
          maximumPriceOfOrder: voucherGroup.maximumPriceOfOrder,
          // nové ceny
          minimumPricesOfSingleItem: voucherGroup.minimumPricesOfSingleItem
            ? voucherGroup.minimumPricesOfSingleItem.map((p: GQL.IPrice) => {
                return exportRawPriceObject(p);
              })
            : null,
          maximumPricesOfSingleItem: voucherGroup.maximumPricesOfSingleItem
            ? voucherGroup.maximumPricesOfSingleItem.map((p: GQL.IPrice) => {
                return exportRawPriceObject(p);
              })
            : null,
          minimumPricesOfOrder: voucherGroup.minimumPricesOfOrder
            ? voucherGroup.minimumPricesOfOrder.map((p: GQL.IPrice) => {
                return exportRawPriceObject(p);
              })
            : null,
          maximumPricesOfOrder: voucherGroup.maximumPricesOfOrder
            ? voucherGroup.maximumPricesOfOrder.map((p: GQL.IPrice) => {
                return exportRawPriceObject(p);
              })
            : null,
          // tagy
          includedProductTags: voucherGroup.includedProductTags || null,
          excludedProductTags: voucherGroup.excludedProductTags || null,
          includedProducts: (voucherGroup as any).includedProductIds || [],
          // doprava zdarma
          freeShipping: (voucherGroup as any).deliveryMethodIds || [],
          // zákaznické skupiny
          customerGroups: (voucherGroup as any).customerGroupsIds || [],
          giftId: voucherGroup.giftId || null,
          customerIds: (Array.isArray((voucherGroup as any).customerIds) && (voucherGroup as any)._isIndividualCustomerVoucher) ? (voucherGroup as any).customerIds : undefined,
        }
      };

      if (voucherGroup.id) {
        return updateVoucherGroup({ variables })
          .then(() => this.setCurrentVoucherGroup(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Voucher group "${variables.voucherGroup.title}" has been updated.`
            })
          );
      }

      createVoucherGroup({ variables })
        .then(() => this.setCurrentVoucherGroup(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Voucher group "${variables.voucherGroup.title}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupTable.tsx